'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetMarket, useGetMarketBoosterLeaderboard } from '@morfi/backend-sdk-v2/client';
import { useEffect } from 'react';
import { canBoostMarket } from '@/lib/market/can-boost-market';
import { logger } from '@/lib/telemetry/logger';
import { MarketBoostersSummaryView } from './market-boosters-summary-view';
import { MarketBoostersTab } from './market-boosters-tab';
export function MarketBoostersSummary(t0) {
  const $ = _c(26);
  const {
    marketPubkey,
    marketStatus
  } = t0;
  let t1;
  if ($[0] !== marketPubkey) {
    t1 = {
      pubkey: marketPubkey
    };
    $[0] = marketPubkey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const market = useGetMarket(t1);
  let t2;
  if ($[2] !== marketPubkey) {
    t2 = {
      pubkey: marketPubkey,
      sortBy: "amount",
      sortOrder: "desc"
    };
    $[2] = marketPubkey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const leaderboard = useGetMarketBoosterLeaderboard(t2);
  const failed = market.isError || leaderboard.isError;
  let t3;
  let t4;
  if ($[4] !== failed || $[5] !== marketPubkey) {
    t3 = () => {
      if (failed) {
        logger.warn("market.boosters.summary_load_failed", {
          marketPubkey
        });
      }
    };
    t4 = [failed, marketPubkey];
    $[4] = failed;
    $[5] = marketPubkey;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  const t5 = market.data?.numBoosters ?? null;
  let t6;
  if ($[8] !== leaderboard.rows) {
    t6 = leaderboard.rows.slice(0, 3).map(_temp);
    $[8] = leaderboard.rows;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = market.isPending || leaderboard.isPending;
  let t8;
  if ($[10] !== marketStatus) {
    t8 = canBoostMarket({
      status: marketStatus
    });
    $[10] = marketStatus;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== leaderboard || $[13] !== market) {
    t9 = () => {
      if (market.isError) {
        market.refetch();
      }
      if (leaderboard.isError) {
        leaderboard.refetch();
      }
    };
    $[12] = leaderboard;
    $[13] = market;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== marketPubkey || $[16] !== marketStatus) {
    t10 = <MarketBoostersTab marketPubkey={marketPubkey} marketStatus={marketStatus} isActive={true} />;
    $[15] = marketPubkey;
    $[16] = marketStatus;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== failed || $[19] !== t10 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t11 = <MarketBoostersSummaryView count={t5} boosters={t6} pending={t7} failed={failed} boostable={t8} onOpen={t9}>{t10}</MarketBoostersSummaryView>;
    $[18] = failed;
    $[19] = t10;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
function _temp(entry) {
  return {
    ...entry,
    booster: {
      ...entry.booster,
      connectedProviders: [...(entry.booster.connectedProviders ?? [])]
    }
  };
}